import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter5_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was bedeutet BYOD?",
      options: [
        {
          value: "A",
          label:
            "Mitarbeiter nutzen ihre privaten Geräte für berufliche Zwecke.",
        },
        {
          value: "B",
          label:
            "Mitarbeiter dürfen unternehmenseigene Laptops kaufen. ",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Was ist eine zentrale Herausforderung bei der Einführung von BYOD?",
      options: [
        {
          value: "A",
          label:
            "Die Sicherstellung des Datenschutzes und der Trennung von privaten und beruflichen Daten.",
        },
        {
          value: "B",
          label: "Die Übertragung der Garantie der Geräte auf das Unternehmen.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 5_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "5_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("5_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 5_2.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "5_2",
              completedChapters: ["5_2"],
            });
          console.log("Dokument erstellt mit Kapitel 5_2");
        }

        navigate("/5_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  5. Endpunktsicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                BYOD (Bring Your Own Device)
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 5: Endpunktsicherheit</h3>
          <h2 className="text-center p-3">BYOD (Bring Your Own Device) </h2>
          <img
            src="/images/byod.png"
            alt="BYOD"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 pt-5 mx-auto">
            Die Bring-Your-Own-Device-Strategie (BYOD) hat die moderne
            Arbeitswelt revolutioniert, da es Mitarbeitern erlaubt wird,
            persönliche Geräte wie Laptops, Tablets und Smartphones für
            berufliche Zwecke zu nutzen. Deren größter Vorteil ist die
            Flexibilität: Mitarbeiter können mit ihren eigenen, vertrauten
            Geräten zu individuellen Zeiten arbeiten, was nicht nur die{" "}
            <strong> Produktivität steigert, </strong>
            sondern auch die <strong> Zufriedenheit erhöht. </strong>{" "}
            Schließlich kennt jeder sein eigenes Smartphone oder Laptop besser
            als ein standardisiertes Firmengerät. <br />
            <br />
            Durch die Möglichkeit, berufliche und private Aufgaben auf einem
            einzigen Gerät zu bündeln wird der Verwaltungsaufwand reduziert. Der Arbeitsalltag wird einfacher und effizienter.
            <br />
            <br />
            BYOD ermöglicht Unternehmen, einfach und flexibel auf wechselnde
            Anforderungen wie Remote-Arbeitsmodellen oder hybrides Arbeiten zu
            reagieren. So entsteht eine große <strong> Kosteneffizienz. </strong> Die Ausgaben für die
            Bereitstellung und Wartung von Geräten entfallen weitgehend, wodurch
            Mittel für strategische Investitionen freigesetzt werden. Zudem bleiben
            Unternehmen technologisch aktuell, da viele Mitarbeiter ihre
            privaten Geräte regelmäßig erneuern und moderne Technologien nutzen.
            <br />
            <br />
            Aber BYOD ist mehr als nur eine technische Entscheidung – es ist ein{" "}
            <strong> agiler Ansatz, </strong> der Unternehmen ermöglicht, die
            Eigenverantwortung und Kreativität ihrer Mitarbeiter zu fördern.
            Indem Mitarbeiter auf ihren bevorzugten Geräten arbeiten, können sie
            die Tools nutzen, die optimal zu ihrer Arbeitsweise passen. Das steigert nicht nur die Motivation, sondern auch die Innovationskraft im Unternehmen. Der BYOD-Ansatz basiert auf Vertrauen. Er gibt den Mitarbeitern die Freiheit, ihre Arbeitsumgebung individuell zu
            gestalten.
          </p>
          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Eine Studie von Frost & Sullivan ergab, dass Mitarbeiter, die BYOD
            nutzen, im Durchschnitt 58 Minuten pro Tag produktiver sind. Der
            Hauptgrund: Sie arbeiten auf Geräten, die sie gut kennen und
            effizient bedienen können.
          </p>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="pt-5 text-center">
            <h3 className="p-5"> Die Risiken von BYOD</h3>

            <p className="col-lg-11 mx-auto">
              Eine der größten Risiken von BYOD liegt in der fehlenden
              Standardisierung von Sicherheitsmaßnahmen. Nicht jedes Gerät ist
              geeignet. <strong> Veraltete Geräte </strong> stellen ein
              erhebliches Sicherheitsrisiko dar, da sie keine Updates mehr
              erhalten. Dann wird aus "Bring your own Device" schnell ein "Bring
              your own Disaster"! <br />
              <br />
              Private Geräte entziehen sich häufig den strengen Kontrollen, die
              für unternehmenseigene Geräte gelten. Sie sind oft nicht
              ausreichend gegen Malware geschützt oder verfügen über keine
              robusten Zugangskontrollen. Diese Schwachstellen bieten
              potenziellen Angreifern eine ideale Angriffsfläche.
              <br />
              <br />
              Hinzu kommt die Gefahr durch das Nutzen öffentlicher
              WLAN-Netzwerke: Greifen Mitarbeitende von unterwegs auf
              Unternehmensressourcen zu, steigt das Risiko von Datenabgriffen
              durch Cyberkriminelle erheblich.
              <br />
              <br />
              Durch BYOD fühlen sich Mitarbeiter aber auch oft verpflichtet,
              außerhalb der Arbeitszeiten verfügbar zu sein, da sie jederzeit auf Unternehmensressourcen zuzugreifen könnten. Dies
              kann zu zusätzlichem Stress und dadurch zu sicherheitsrelevanten Fehlverhalten führen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              61% der Unternehmen erwarten von ihren Mitarbeitern, dass sie auch
              im Homeoffice erreichbar sind, selbst wenn ihnen kein Firmengerät
              zur Verfügung gestellt wird. So sind viele Mitarbeiter
              gezwungen, ihre privaten Geräte für berufliche Zwecke zu
              nutzen. (Samsung)
            </p>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5"> Datenschutz im BYOD-Modell</h3>

            <p className="col-lg-11 mx-auto">
              Die{" "}
              <strong> Vermischung von beruflichen und privaten Daten </strong>{" "}
              auf einem Gerät birgt sowohl für Unternehmen als auch für
              Mitarbeiter Risiken. Unternehmen sollten daher klare Richtlinien
              entwickeln, die Sicherheitsmaßnahmen einschließen, ohne die
              Privatsphäre der Mitarbeiter übermäßig einzuschränken.
              Mitarbeitern haben oft Bedenken, wenn die IT-Abteilung Kontrolle
              über ihre persönlichen Geräte bekommt. Um die Akzeptanz zu fördern, müssen Unternehmen hier einen transparenten und ausgewogenen Ansatz verfolgen, in dem klar
              kommuniziert wird, welche Daten die IT-Abteilung überwachen kann und darf.
              <br />
              <br />
              Um BYOD rechtskonform zu gestalten, sollten Mitarbeiter{" "}
              <strong> schriftlich einwilligen, </strong> wie ihre Geräte im
              beruflichen Kontext genutzt werden und welche Daten verarbeitet
              werden dürfen. Diese Einwilligung schafft Transparenz und stellt
              sicher, dass alle Beteiligten die Bedingungen kennen und
              akzeptieren. Dabei ist es natürlich notwendig, die rechtlichen
              Anforderungen der Branche (z. B. Finanzunternehmen oder
              Gesundheitswesen) oder des Landes (DSGVO) zu erfüllen.
              <br />
              <br />
              Idealerweise sollten sensible
              Unternehmensdaten getrennt von persönlichen Informationen
              gespeichert oder verarbeitet werden. Dies kann z. B. durch den
              Einsatz von
              <strong> Container-Apps </strong> erfolgen. Container-Apps sind
              spezielle Anwendungen, die einen geschützten Bereich auf einem
              Gerät erstellen, in dem Unternehmensdaten und Anwendungen isoliert
              von privaten Daten gespeichert werden. Sie ermöglichen eine klare
              Trennung und erhöhen die Sicherheit, da sensible Daten in einem
              abgeschotteten „Container“ verbleiben, der von der restlichen
              Gerätesoftware getrennt ist.
              <br />
              <br />
              Auch so genannte <strong> Dual-Profile-Funktionen </strong>{" "}
              erlauben es, auf einem Gerät zwei getrennte Benutzerprofile
              einzurichten: Eines für berufliche und eines für private Zwecke.
              Diese Funktion sorgt dafür, dass Arbeitsdaten und private Inhalte
              unabhängig voneinander verwaltet werden, sodass
              Sicherheitsrichtlinien nur auf das berufliche Profil angewendet
              werden.
              <br />
              <br />
              Darüber hinaus sollten Unternehmen alle Prozesse und Richtlinien
              im Zusammenhang mit BYOD detailliert dokumentieren. Diese{" "}
              <strong> Dokumentation </strong> dient nicht nur der internen
              Nachverfolgung. Sie ist auch notwendig, um bei einer Prüfung
              durch Datenschutzbehörden nachweisen zu können, dass alle Vorgaben
              eingehalten wurden.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              In Europa stellt die DSGVO (Datenschutz-Grundverordnung) eine
              große Hürde für die Umsetzung des BYOD-Modells dar. Unternehmen müssen
              sicherstellen, dass persönliche Geräte DSGVO-konform verwendet
              werden, insbesondere wenn es um die Verarbeitung personenbezogener
              Daten geht. Verstöße können zu erheblichen Bußgeldern führen,
              weshalb viele Unternehmen BYOD nur eingeschränkt zulassen. In
              Deutschland beispielsweise lehnen 42% der Unternehmen BYOD ab,
              während in den USA nur 18% der Unternehmen auf private Geräte
              verzichten.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="pt-5 container">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">BYOD-Policy</h3>
            <p className="col-lg-11 mx-auto">
              Eine effektive BYOD-Policy legt klare Rahmenbedingungen fest, die
              die Nutzung privater Geräte in einem beruflichen Kontext regeln.
              Sie sollte dabei zentrale Fragen beantworten:{" "}
            </p>
            <p className="col-lg-8 text-start mx-auto">
              <ul>
                <li>Wer erhält Zugriff auf welche Ressourcen?</li>
                <li>
                  Welche Gerätetypen und Betriebssysteme sind zugelassen?{" "}
                </li>
                <li>
                  Unter welchen Umständen – etwa von welchen Standorten oder
                  Netzwerken aus – darf auf Unternehmensdaten zugegriffen
                  werden?
                </li>
               
                <li>
                  Gibt es zeitliche Einschränkungen für den Zugriff auf diese
                  Daten?
                </li>
              </ul>
            </p>
            <p className="col-lg-11 pt-3 pb-5 mx-auto">
              Entscheidend ist, dass diese Lösungen nicht nur die Anforderungen
              des Unternehmens erfüllen, sondern auch die Nutzererfahrung der
              Mitarbeiter berücksichtigen, um Vertrauen und Akzeptanz zu
              fördern.{" "}
            </p>
            <p className="col-lg-11 pt-3  mx-auto">
              Eine der größten Herausforderungen im BYOD-Kontext ist der Schutz
              sensibler Unternehmensdaten, die auf persönlichen Geräten
              gespeichert oder verarbeitet werden. Eine zentrale
              Sicherheitsrichtlinie sollte definieren,{" "}
            </p>
            <p className="col-lg-8 text-start mx-auto">
              <ul>
                <li>welche Daten als sensibel gelten,</li>
                <li>wer auf sie zugreifen darf und </li>
                <li>unter welchen Bedingungen der Zugriff erfolgen darf.</li>
               
                <li>welche Maßnahmen bei Verstößen ergriffen werden.</li>
              </ul>
            </p>
            <p className="col-lg-11 pt-3 mx-auto">
              Sicherheitsrichtlinien müssen pragmatisch
              gestaltet werden, also weder zu kompliziert, noch zu unflexibel.  <br />
              <br />
              Unternehmen sollten unmissverständlich definieren, wie Mitarbeiter
              mit sensiblen Daten umgehen dürfen. Das schließt auch die
              Festlegung verbotener Aktivitäten ein, beispielsweise die Nutzung
              bestimmter Websites oder Anwendungen, die als potenzielles Risiko
              gelten. Solche Richtlinien schützen nicht nur das Unternehmen vor
              Datenverlusten, sondern reduzieren auch rechtliche Risiken.
              <br />
              <br />
              Schriftliche Nutzungsvereinbarungen, die die Verantwortlichkeiten
              der Mitarbeiter und die Erwartungen des Unternehmens klar
              darlegen, sind unverzichtbar. Sie sorgen dafür, dass alle
              Beteiligten über ihre Rechte und Pflichten informiert sind und
              schaffen gleichzeitig die Grundlage für eine sichere und
              rechtskonforme Nutzung persönlicher Geräte im Unternehmenskontext.
            </p>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter5_2;
